import { useEffect, useState } from "react";
import { Table, Tag, Spin } from "antd";
import { Filters, Dates, Toast } from "utils";
import { findUserBillings } from "services/financialData";
import { getLabelByStatus } from "features/FinancialData/utils";
import { Container } from "./styles";

const BILLING_TYPE_LABELS = {
  BOLETO: "Boleto",
  CREDIT_CARD: "Cartão de crédito",
  PIX: "PIX",
  UNDEFINED: "Não definido",
};

export const UserBillings = ({ idUser }) => {
  const [billings, setBillings] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBillings = async () => {
    try {
      setLoading(true);
      const { data, ok } = await findUserBillings(idUser);
      if (ok) setBillings(data || []);
      else Toast.showErrorMessage("Erro ao carregar os dados financeiros.");
    } catch (error) {
      console.error(error);
      Toast.showErrorMessage("Erro ao carregar os dados financeiros.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idUser) fetchBillings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUser]);

  const columns = [
    { title: "Curso", dataIndex: "nome_curso", key: "nome_curso" },
    {
      title: "Tópico",
      dataIndex: "nome_topico",
      key: "nome_topico",
      render: (value) => value || "-",
    },
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      render: (value) => value || "-",
    },
    {
      title: "Valor",
      dataIndex: "value",
      key: "value",
      width: 120,
      render: (value) => Filters.convertMoneyTextMask(value || 0),
    },
    {
      title: "Vencimento",
      dataIndex: "dueDate",
      key: "dueDate",
      width: 130,
      render: (value) => (value ? Dates.transformDateToDayMonthYear(value) : "-"),
    },
    {
      title: "Cód. desconto",
      dataIndex: "codigo_promocional",
      key: "codigo_promocional",
      width: 150,
      render: (value, record) =>
        value
          ? `${value}${record.pr_desconto ? ` (${record.pr_desconto}%)` : ""}`
          : "-",
    },
    {
      title: "Tipo de pagamento",
      dataIndex: "billingType",
      key: "billingType",
      width: 160,
      render: (value) => BILLING_TYPE_LABELS[value] || value || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (value) => {
        const label = getLabelByStatus(value);
        return <Tag color={label.color}>{label.status}</Tag>;
      },
    },
  ];

  return (
    <Container>
      <Spin spinning={loading}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={billings}
          pagination={false}
          locale={{ emptyText: "Nenhum dado financeiro encontrado." }}
        />
      </Spin>
    </Container>
  );
};
